import React from "react";
import Row from "../../../../../common/components/shared/row/row";
import TextInput from "../../../../../common/components/shared/textInput/textInput";
import {storesContext} from "../../../../../common/stores/stores";
import i18n from "../../../../../i18n/i18n";
import {IOrderStore} from "../../../../stores/orderStore";
import DropDown from "../../../../../common/components/shared/dropDown/dropDown";
import {DropDownModel} from "../../../../../common/models/dropDown";
import {ContainerSizeType} from "../../../../models/container";
import {getContainerSize} from "../../../../../helpers/containerSize";
import {observer} from "mobx-react";

class ContainerSection extends React.Component {
    static contextType = storesContext;

    render() {
        const orderStore = this.context.orderStore as IOrderStore;

        return (
            <div className="section">
                <div className="section-header">
                    {i18n.t("transportation.order.details.container.header")}
                </div>
                <div className="section-content">
                    <Row class="flex-type gap-30">
                        <TextInput
                            label={i18n.t("transportation.order.details.container.properties.containerNo")}
                            validatedValue={orderStore.containerNo}
                            testId="container-no"
                            offAutocomplete
                        />
                        <DropDown
                            className="element container-size"
                            label={i18n.t("transportation.order.details.container.properties.containerSize")}
                            items={this.containerSizeToDropdown()}
                            validatedValue={orderStore.containerSize}
                            testId="container-size"
                            withEmptyValue
                            withoutSort
                        />
                        <TextInput
                            label={i18n.t("transportation.order.details.container.properties.vgm")}
                            validatedValue={orderStore.vgm}
                            testId="vgm"
                            unit="kg"
                            offAutocomplete
                        />
                    </Row>
                </div>
            </div>
        );
    }

    private containerSizeToDropdown(): DropDownModel[] {
        const containerSizeDropDown: DropDownModel[] = [];

        for (const key in ContainerSizeType) {
            containerSizeDropDown.push({id: key, name: getContainerSize(key as ContainerSizeType)});
        }

        return containerSizeDropDown;
    }
}

export default observer(ContainerSection);